<template ref="appdom">
  <div id="app">
      <header1></header1>
      <router-view/>
  </div>
</template>

<script>
  import header1 from './components/Header.vue'
export default {
  name: 'app',
  components: {
    header1: header1
  },
  methods: {
    scroll_top () {
     $('html,body').animate({scrollTop:0},300);
   }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  @import "../static/assets/main.scss";
*{
  margin:0;
  padding:0;
  text-decoration: none;
}

  body,html,#app{
    background: #f9f9f9;
    color:#4f4f4f;
    width: 100%;
    height: 100%;
    min-width: 1200px;
  }
.app-box{
  height: 100%
}
 .el-table .el-table__body-wrapper{
    overflow: hidden;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue